import React, { useState, useEffect, Component } from "react";

import { EditorState, convertToRaw, ContentState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { Fragment } from "react";
// import "./editorStyle.css";

import useStyles from "./style";

const TextEditor = ({ initialHtmlContent, onHtmlContentChange }) => {
  const classes = useStyles();

  const [editorState, setEditorState] = useState(() => {
    const contentBlock = htmlToDraft(initialHtmlContent);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      return EditorState.createWithContent(contentState);
    }
    return EditorState.createEmpty();
  });

  const onEditorStateChange = (newEditorState) => {
    setEditorState(newEditorState);
  };

  useEffect(() => {
    onHtmlContentChange(
      draftToHtml(convertToRaw(editorState.getCurrentContent()))
    );
  }, [editorState, onHtmlContentChange]);

  return (
    <>
      <div className="App">
        <header className={classes.AppHeader}>CMS EDITOR </header>
        <br></br>
        <Editor
          editorState={editorState}
          onEditorStateChange={onEditorStateChange}
          wrapperClassName={classes.wrapperClass}
          editorClassName={classes.editorClass}
          toolbarClassName={classes.toolbarClass}
        />
        {/* <textarea
          disabled
          value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
        /> */}
      </div>
    </>
  );
};

export default TextEditor;
